import React, { useState } from 'react';
import '../Sources/SourceForm.css';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

function EnquiryTopicForm({ initial, redirects = [], onSave, onCancel, loading }) {
  const [name, setName] = useState(initial?.name || '');
  const [redirectTo, setRedirectTo] = useState(initial?.redirect_to || '');
  const [error, setError] = useState('');

  const validate = () => {
    if (!name.trim()) return 'Name is required.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({ name: name.trim(), redirect_to: redirectTo || null });
  };

  return (
    <form className="source-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div>
        <label>Name<RequiredMark /></label><br />
        <input
          className="styled-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={100}
          placeholder="e.g., Product question"
          style={{ width: 260 }}
        />
      </div>

      <div style={{ marginTop: 12 }}>
        <label>Redirect to</label><br />
        <select className="styled-input" value={redirectTo} onChange={(e) => setRedirectTo(e.target.value)} style={{ width: 260 }}>
          <option value="">None</option>
          {redirects.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
        </select>
        <div style={{ fontSize: 12, color: '#5a6b85', marginTop: 4, maxWidth: 360 }}>The page a visitor who picks this Topic is sent to, instead of sending their enquiry.</div>
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default EnquiryTopicForm;
